import React, { useState, useEffect } from "react";
import { Rating } from "react-simple-star-rating";
import axios from "axios";

function ServiceModel({ isOpen, onClose, serviceId, projectId, authInfo, fetchApi }) { // ✅ NEW: Add projectId prop
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState({ title: "", description: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();
    //Validate projectId is provided
    //console.log("PROJ ID: ", projectId)
    if (!projectId) {
      console.error("Project ID is required for review submission");
      alert("Project ID is missing. Cannot submit review.");
      return;
    }

    try {
      const reviewData = {
        title: review.title,
        description: review.description,
        rating: rating,
        serviceId: serviceId,
        projectId: projectId, // Include projectId
        userId: authInfo.id,
      };

      console.log("service reviewData", reviewData);

      await axios.post(`/user/service-review`, reviewData);
      console.log("Review submitted successfully!");
      
      //called get api for show updated data
      fetchApi();
      
      // Clear the form fields after successful submission
      setRating(0);
      setReview({ title: "", description: "" });
      
      onClose();
    } catch (error) {
      console.error("Error submitting review:", error);
      
      // handle specific error messages
      if (error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert("Failed to submit review. Please try again.");
      }
    }
  };

  //Handle OnChange
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setReview({ ...review, [name]: value });
  };

  return (
    <React.Fragment>
      <div
        className={`modal ${isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
      >
        {/* Modal content */}
        <div className="modal-xl modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Write a Review</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="reviewTitle" className="form-label">
                    Add a headline
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="reviewTitle"
                    name="title"
                    value={review.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="reviewDescription" className="form-label">
                    Add a written review
                  </label>
                  <textarea
                    className="form-control"
                    id="reviewDescription"
                    name="description"
                    rows="3"
                    value={review.description}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>
                <div className="mb-3">
                  <label htmlFor="rating">Rating</label>
                  <br />
                  <Rating
                    allowFraction
                    onClick={(value) => setRating(value)}
                    ratingValue={rating}
                  />
                </div>
                <button type="submit" className="btn custom_btn btn_yellow">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ServiceModel;